import Vue from "vue";
import VueI18n from "vue-i18n";

// デフォルト表示言語は「日本語」
let locale = "ja";
// ブラウザから表示言語を取得
const language = window.navigator.language;
// Step1では日本語のみ対応
if (language) {
  const lang = language.toLowerCase().split("-");
  switch (lang[0]) {
    case "ja":
    case "en":
      locale = "ja";
      break;
  }
}

Vue.use(VueI18n);

export const i18n = new VueI18n({
  locale: "ja",
  fallbackLocale: "ja",
  messages: importLanguage()
});

function setI18nLanguage(lang) {
  // Axiosの言語設定 : 今回はしない
  // axios.defaults.headers.common['Accept-Language'] = lang;
  // HTMLの言語設定 : 今回はしない
  // document.querySelector('html').setAttribute('lang', lang);
  return lang;
}

export function importLanguage() {
  return import(`./assets/i18n/${locale}.json`).then(messages => {
    i18n.setLocaleMessage(locale, messages.default);
    return setI18nLanguage(locale);
  });
}
